/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminOwnerGetOwnersFromOrganizationParams,
  OrganizationUserAdminDTOQueryResultDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminOwnerGetOwnersFromOrganization = (
    organizationId: number,
    params?: AdminOwnerGetOwnersFromOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserAdminDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOwner`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminOwnerGetOwnersFromOrganizationQueryKey = (organizationId: number,
    params?: AdminOwnerGetOwnersFromOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOwner`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminOwnerGetOwnersFromOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminOwnerGetOwnersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOwnerGetOwnersFromOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>> = ({ signal }) => adminOwnerGetOwnersFromOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOwnerGetOwnersFromOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>>
export type AdminOwnerGetOwnersFromOrganizationQueryError = ErrorType<unknown>


export function useAdminOwnerGetOwnersFromOrganization<TData = Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminOwnerGetOwnersFromOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOwnerGetOwnersFromOrganization<TData = Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOwnerGetOwnersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOwnerGetOwnersFromOrganization<TData = Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOwnerGetOwnersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOwnerGetOwnersFromOrganization<TData = Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOwnerGetOwnersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOwnerGetOwnersFromOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOwnerGetOwnersFromOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



